module.exports = "/_next/static/images/6d7cf1ee297409a80665b3cd9e5fe981-image-left-lg.jpg.webp";